import React from "react";

export const LazyWormCallPaletteInsert = React.lazy(() =>
    import(/* webpackChunkName: "WormCall" */ "./PaletteInsert").then(x => ({
        default: x.PaletteInsert
    }))
);
